import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetSearchEngineAggregateLinksQuery, useLazyGetSearchEngineLinksQuery } from '../../redux/apis/linkManagement/searchEngine/lMSearchEngineApiSlice'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import generateExcel from '../../helpers/generateExcel'

const SearchEngineReviewing = React.memo(() => {
  const context = useContext(AppSettings)
  const [fetchLinks] = useLazyGetSearchEngineLinksQuery()
  const [downloadingId, setDownloadingId] = useState(null)
  const { data, isLoading, error, refetch, isUninitialized } = useGetSearchEngineAggregateLinksQuery()

  const handleDownload = async (record) => {
    setDownloadingId(record.campaign_id)
    toast.info('Preparing download...')
    try {
      const result = await fetchLinks({
        campaign: record.campaign_id,
        page: '*',
        fields: ['id', 'customers', 'url', 'campaign.campaign_name'].join(','),
        expand: ['campaign'].join(',')
      })
      const rows = result.data?.data?.results ?? []
      generateExcel(
        rows.map(item => ({
          clients: item.customers?.join(', '),
          campaign: item.campaign?.campaign_name,
          url: item.url,
        })),
        `${record.campaign_name}`
      )
      toast.success('Download ready')
    } catch {
      toast.error('Failed to download data')
    } finally {
      setDownloadingId(null)
    }
  }

  let columns = [
      { title: 'Campain ID', dataIndex: 'campaign_id', key: 'campaign_id', sorter: true },
      {
        title: 'CAMPAIGN NAME',
        dataIndex: 'campaign_name',
        key: 'campaign_name',
          search: true
      },
      {
        title: 'CUSTOMERS',
        dataIndex: 'customers',
        key: 'customers',
          search: true,
        render: (customers, record) => <>{customers?.map(x=>x)?.join(', ')}</>
      },
  
      {
        title: 'SCREENSHOTS COUNT',
        dataIndex: 'to_review_count',
        key: 'to_review_count',
          search: true
      },
      
  
      {
        title: 'Actions',
        dataIndex: 'campaign_id',
        key: 'actions',
        render: (text, record) => (
          <div className='flex gap-2'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={`/reviewing-screenshots/search-engine/campaign/${record?.campaign_id}`}
              className='btn btn-outline-theme'
            >
              Review
            </a>
            <button
              className='btn btn-outline-theme'
              onClick={() => handleDownload(record)}
              disabled={downloadingId === record.campaign_id}
            >
              {downloadingId === record.campaign_id ? 'Downloading...' : 'Download'}
            </button>
          </div>
        )
      }
    ]
    useEffect(() => {
      console.log(error)
      if (error) {
        
        toast.error(error)
      }
    }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !isUninitialized) {
        refetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch, isUninitialized])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading} />
      
      <div className='row'>
        <ReusableTable columns={columns} data={data?.data} />
      </div>
    </div>
  )
})

export default SearchEngineReviewing
